<template>
  <div class="text-center">
    <HMModalHeader :title="$t('GENERAL.TEXT.THANK_YOU')" @close="close" />
    <img src="/assets/images/gift.svg" />
    <h2 class="mt-3">
      {{ $t('PRODUCTS.TEXT.YOU_PURCHASED_A_GIFT_FOR', { email: email }) }}
    </h2>
    <HMButton class="mt-3" color="brand" @click="close">
      {{ $t('PRODUCTS.BUTTON.CONTINUE') }}
    </HMButton>
  </div>
</template>

<script>
export default {
  name: 'GiftPurchaseModal',
  props: {
    email: {
      type: String,
      required: true,
    },
    closeFn: null,
  },
  methods: {
    close() {
      if (this.closeFn) this.closeFn();
      this.$attrs._close()
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';
</style>
